import { render } from "./CommissionDetail.vue?vue&type=template&id=f9fa0b72&scoped=true"
import script from "./CommissionDetail.vue?vue&type=script&lang=js"
export * from "./CommissionDetail.vue?vue&type=script&lang=js"

import "./CommissionDetail.vue?vue&type=style&index=0&id=f9fa0b72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9fa0b72"]])

export default __exports__